<template>
  <v-container v-if="visit" class="ma-1 pa-0">
    <v-row align="center">
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead class="header"><tr>
              <!-- <th class="text-left">id</th> -->
              <th class="text-left"></th>
              <th class="text-left">{{tLabel('License Plate')}}</th>
              <th class="text-left">{{tLabel('Owner')}}</th>
              <th class="text-left">{{tLabel('Status')}}</th>
            </tr></thead>
            <tbody><tr>          
              <!-- <td>{{ visit.id }}</td> -->
              <td><v-icon color="primary">{{iconMap["RRO"]}}</v-icon></td>
              <td>{{ visit.objectCode }}</td>
              <td>{{ visit.owner }}</td>
              <td>
                <EnumVisualization :value="visit.status" :enums="visitStatus" :enumsMap="visitStatusMap"/>        
              </td>        
            </tr></tbody>
          </template>
        </v-simple-table>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
import YardEnumMixin from "../../mixins/yard/EnumMixin";
import EnumVisualization from '@/components/yard/EnumVisualization.vue';

export default {
  name: "RoroVisitViewPanelLite",
  props: {
    visit: {
      type: Object,
      required: true      
    },
  },
  data() {
    return {

    };
  },

  async mounted() {

  },
  mixins: [YardEnumMixin],
  components: {
    EnumVisualization
  },
};
</script>